/**
 * The mobile break point at which we switch between mobile and desktop
 */
export const mobileBreakpoint: number = 768;
